import loading from './loading';
import * as api from '../components/EstimateCard/AddToOrder/api';
import * as designBuilderApi from '../api/designBuilder';
import globalError from './globalError';
import loaded from './loaded';
import getRonaeleOrderDetailsUrl from '../helpers/getRonaeleOrderDetailsUrl';
import controlWindowsWithInvalidConfigurationsModal from './uiState/controlWindowsWithInvalidConfigurationsModal';

export default (calculateTaxModel, designId) => async (dispatch, getState) => {
  dispatch(loading());
  try {
    const configurationGuids = calculateTaxModel.lineItems.map(x => x.lineItemGroupGuid);
    const configResponse = await api.ValidateAndRepriceConfigurations(configurationGuids);
    const goodConfigurations = configResponse.data
      .filter(x => x.ResponseCode === 200)
      .map(x => x.ConfigurationGuid);

    const problematicConfigs = configResponse.data
      .filter(x => !goodConfigurations.includes(x.ConfigurationGuid))
      .map(x => x.ConfigurationGuid);

    if (problematicConfigs.length > 0) {
      const { entities } = getState().estimateBuilder;
      const { estimates, containers, items } = entities;
      const selectedEstimate = estimates.byId[designId];

      const containersForSelectedEstimate = selectedEstimate.containers
        .map(containerId => containers.byId[containerId]);

      const itemsForEstimate = containersForSelectedEstimate
        .map(container => container.items)
        .reduce((a, b) => a.concat(b), [])
        .map(itemId => items.byId[itemId]);

      const windowNames = itemsForEstimate
        .filter(x => problematicConfigs.includes(x.itemProduct.configurationGuid))
        .map(x => x.label);

      dispatch(loaded());
      dispatch(controlWindowsWithInvalidConfigurationsModal(true, windowNames));
      return;
    }
    await api.StartChangeOrder(3, calculateTaxModel.orderNumber);
    await api.AddLineItems(3, calculateTaxModel.orderNumber, configurationGuids);
    await api.CompleteChangeOrder(3, calculateTaxModel.orderNumber);
    await designBuilderApi.setDesignAttribute(designId, { name: 'isAutoReleaseCompleted', value: true });

    location.href = getRonaeleOrderDetailsUrl(
      calculateTaxModel.siteId,
      calculateTaxModel.orderNumber,
    );
  } catch (e) {
    dispatch(globalError({
      text: 'We are sorry, but we are unable to complete this action at this time.  Please try again.',
    }));
  }
};
